<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs2-13",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 33,
      nextPage: '/questionnaire/section2/14',
      navigateType: 'CLICK_ANY_BTN',
      content: {
        componentsType: {
          pc: 'longBtn',
          mobile: 'normalBtn'
        },
        titleIcon: require('@/assets/icon/questionIcon/21-Emotion.png'),
        mainTitle: 'How often are you anxious:',
        btn: [
          [
            {
              text: 'Everyday',
            }
          ],[
            {
              text: 'Every two or three days',
            }
          ],[
            {
              text: 'Once a week',
            }
          ],[
            {
              text: 'Rarely',
            }
          ]
        ]
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
